<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13EcIvO/tc-custom/9781616892944.jpg?1705260591704" alt="This image is the cover for the book Designer Says"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Designer Says
      </h1>
      <p class="bookDescription body article font2">
        <b>“An inspirational reference with words from the likes of Saul Bass, Stephen Doyle, Milton Glaser, Chip Kidd and Paula Scher.” —<i>Cool Hunting</i></b><br/>  <br/> Whether musing about the creative process, the merits of failure and criticism, or the challenges of keeping the studio lights on, designers have opinions. <i>The Designer Says</i> is a compendium of quotations from more than one hundred of history’s leading practitioners. On the page they’re mixed like guests at a dinner party—a nineteenth-century designer might sit next to one working today, or two contemporary designers may strike up a conversation. Listen in as they complime nt, provoke, and one-up each other in this lively volume of insights for anyone curious about the ideas and personalities that shape the art of visual communication.<br/>  <br/> This beautifully designed (of course!) compendium features quotations from * Otl <b>Aicher</b> * Saul <b>Bass</b> * Michael <b>Bierut</b> * Irma <b>Boom</b> * Robert <b>Brownjohn</b> * Matthew <b>Carter</b> * Art <b>Chantry</b> * Ivan <b>Chermayeff</b> * Seymour <b>Chwast</b> * Elaine Lustig <b>Cohen</b> * William <b>Drenttel</b> * Charles and Ray <b>Eames</b> * Ed <b>Fella</b> * Alan <b>Fletcher</b> * Adrian <b>Frutiger</b> * Eric <b>Gill</b> * Milton <b>Glaser</b> * Jessica <b>Helfand</b> * Experimental <b>Jetset</b> * Ellen <b>Lupton</b> * Karel <b>Martens</b> * Debbie <b>Millman</b> * L'szl <b>Moholy-Nagy</b> * Bruno <b>Mari</b> * Paul <b>Rand</b> * Michael <b>Rock</b> * Aleksandr <b>Rodchenko</b> * Paula <b>Scher</b> * Kurt <b>Schwitters</b> * Erik <b>Spiekermann</b> * Jan <b>Tschichold</b> * Massimo <b>Vignelli</b> * Hermann <b>Zapf</b> * and many more<br/>  <br/> “Their wisdom comes across in gorgeous type and succinct humor.”—<i>Cool Hunting</i><br/>  <br/> “A charming compendium of more than one hundred beautifully typeset remarks by some of today’s and yesteryear’s most celebrated graphic design minds.” —<i>Brain Pickings</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sara Bader
      </h2>
      
      <p class="authorDescription body article">Sara Bader is an editor, writer, and researcher. She is the author of Strange Red Cow: and Other Curious Classified Ads from the Past, a look at U.S. history though classified advertisements printed over the last three hundred years. Strange Red Cow was featured in the New York Times and the International Herald Tribune, among other newspapers and magazines. Bader is the founder and editor of the website Quotenik.com, a growing library of verified quotations. The online archive is a practical resource for journalists, authors, speechwriters, playwrights, etc. She edits and acquires visual culture books for Princeton Architectural Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      PA Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6985f17e